import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "tw-border-b tw-border-t-0 tw-border-x-0 tw-border-solid tw-m-2 sf-dropdown-item-group__divider"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'sf-dropdown-item-group',
    props: {
        withSeparator: {
            type: Boolean
        }
    },
    setup (__props) {
        return (_ctx, _cache)=>{
            return _openBlock(), _createElementBlock(_Fragment, null, [
                _renderSlot(_ctx.$slots, "default"),
                _cache[0] || (_cache[0] = _createTextVNode()),
                _ctx.withSeparator ? (_openBlock(), _createElementBlock("div", _hoisted_1)) : _createCommentVNode("", true)
            ], 64);
        };
    }
});
